export default __webpack_public_path__ + "img/success-icon.01dadeb6.svg";